import { render, staticRenderFns } from "./RSC.vue?vue&type=template&id=2f4bbe60&"
import script from "./RSC.vue?vue&type=script&lang=js&"
export * from "./RSC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports